export const selectCompetence = state => state.competence;
